import { FC, memo } from 'react';
import { useTranslation } from 'react-i18next';
// Import Types
import type { Sorting } from 'types';
// Import Components
import { Icon, Tooltip } from '@geneui/components';
import SectionWithTitle from 'components/common/SectionWithTitle';
// Import Constants
import { l } from 'constants/common';
import DataTable from 'components/common/DataTable';
// Import Configs
import { DataTableColumnsConfigs } from './config';
import { CampaignAwardCurrencyListItemUIModel } from './types';

const defaultSorting: Sorting = { Name: 'CurrencyId', Direction: 'asc' };

interface CampaignBonusSummaryByCurrencyListProps {
    isLoading?: boolean;
    userCurrencyId?: string;
    data?: CampaignAwardCurrencyListItemUIModel[];
}

const CampaignBonusSummaryByCurrencyList: FC<CampaignBonusSummaryByCurrencyListProps> = ({
    isLoading = true,
    data = [],
    userCurrencyId = '',
}) => {
    const { t } = useTranslation();
    const { columns } = DataTableColumnsConfigs(t, userCurrencyId);

    return (
        <SectionWithTitle
            title={
                <>
                    {t(l.BonusSummaryByCurrency)}
                    <Tooltip text={t(l.BonusSummaryByCurrencyDescription)} position="bottom">
                        <Icon type="bc-icon-info" />
                    </Tooltip>
                </>
            }
            hasContentPadding={false}
            className="c-r-s-with-title"
            contentClassName="c-r-s-with-title-content"
        >
            <DataTable
                name=""
                rowKey="rowKey"
                columnKey="dataKey"
                withPagination={false}
                isShowRefreshButton={false}
                withPageSelector={false}
                data={data}
                dataCount={data.length}
                columns={columns}
                isLoading={isLoading}
                sorting={defaultSorting}
            />
        </SectionWithTitle>
    );
};

export default memo(CampaignBonusSummaryByCurrencyList);
